import * as React from "react"

import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import { IDeal, IProduct } from "shared/hubrise/models"

import { ImageHolder, StyledImage } from "./Styles"

const Image = ({ productOrDeal }: { productOrDeal: IProduct | IDeal }): JSX.Element | null => {
  const { catalogNavigation } = useCatalogNavigation()

  const imageHrId = productOrDeal.imageHrIds[0]
  const imagePath = imageHrId ? catalogNavigation.imagePath(imageHrId) : undefined
  const hasImage = imagePath !== undefined

  if (!hasImage) return null

  return (
    <ImageHolder>
      <StyledImage src={imagePath} alt={productOrDeal.name} />
    </ImageHolder>
  )
}

export default Image
